import styled from 'styled-components';

const StyledAuthWrapper = styled.div`
  height: 100%;
`;

export default StyledAuthWrapper;
